<template>
  <div class="pub-group-subsection">
    <div class="div">Announcement .</div>
    <div class="heading-services">云帆公告</div>
  </div>
</template>

<script>
export default { name: "PubGroupSubsection" };
</script>

<style scoped>
.pub-group-subsection { display: flex; flex-direction: column; gap: 32px; height: 98px; left: 180px; position: absolute; top: 740px; width: 611px; }
.pub-group-subsection .div { color: #00183c; font-family: "Poppins", Helvetica; font-size: 72px; font-weight: 600; height: 36px; letter-spacing: 0; line-height: 36px; white-space: nowrap; width: 607px; }
.pub-group-subsection .heading-services { align-items: center; color: #00183c; display: flex; font-family: "PingFang SC-Regular", Helvetica; font-size: 32px; font-weight: 400; height: 30px; justify-content: center; letter-spacing: 0; line-height: 30px; white-space: nowrap; width: 128px; }
</style>